module.exports = __webpack_public_path__ + "img/cut-05-sp.3c12b081.jpg";